module.exports = __webpack_public_path__ + "media/images/WFC_Landscape_Black-27724ad6374ea781770c0c7c71f5f578.svg";